import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

// merge tailwind classes, last one wins
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
